import React from 'react';

import gradientData from "../gradient_collection_resource.json";
// import Particles from "react-particles-js";
import {Link} from "gatsby";

const mapStateToProps = (state) => ({
  ...state,
});

class FrontendResources extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        gradients: [],
        image_links: ["svg_waves", "waves_violet", "waves_green", "triangle_background1", "triangle_background2", "triangle_background"],
        //image_links: [],
        particleContainer1: {}, 
        // particlesOptions1: {"background":{"color":{"value":"#0d47a1"},"image":"linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)"},"particles":{"number":{"value":80,"density":{"enable":false}},"size":{"value":3,"random":true,"anim":{"speed":4,"size_min":0.3}},"links":{"enable":false},"move":{"random":true,"speed":1,"direction":"top","out_mode":"out"}},"interactivity":{"events":{"onhover":{"enable":true,"mode":"bubble"},"onclick":{"enable":true,"mode":"repulse"}},"modes":{"bubble":{"distance":250,"duration":2,"size":0,"opacity":0},"repulse":{"distance":400,"duration":4}}}},
        particlesOptions1: {"autoPlay":true,"background":{"color":{"value":"#0d47a1"},"image":"","position":"","repeat":"","size":"","opacity":1},"backgroundMask":{"composite":"destination-out","cover":{"color":{"value":"#fff"},"opacity":1},"enable":false},"backgroundMode":{"enable":true,"zIndex":-1},"detectRetina":true,"infection":{"cure":false,"delay":0,"enable":false,"infections":0,"stages":[]},"interactivity":{"detectsOn":"canvas","events":{"onClick":{"enable":true,"mode":"push"},"onDiv":{"selectors":[],"enable":false,"mode":[],"type":"circle"},"onHover":{"enable":true,"mode":"repulse","parallax":{"enable":false,"force":2,"smooth":10}},"resize":true},"modes":{"attract":{"distance":200,"duration":0.4,"speed":1},"bounce":{"distance":200},"bubble":{"distance":400,"duration":2,"opacity":0.8,"size":40},"connect":{"distance":80,"links":{"opacity":0.5},"radius":60},"grab":{"distance":100,"links":{"blink":false,"consent":false,"opacity":1}},"light":{"area":{"gradient":{"start":{"value":"#ffffff"},"stop":{"value":"#000000"}},"radius":1000},"shadow":{"color":{"value":"#000000"},"length":2000}},"push":{"quantity":4},"remove":{"quantity":2},"repulse":{"distance":200,"duration":0.4,"speed":1},"slow":{"factor":3,"radius":200},"trail":{"delay":1,"quantity":1}}},"manualParticles":[],"motion":{"disable":false,"reduce":{"factor":4,"value":false}},"particles":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"collisions":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"enable":true,"mode":"bounce"},"color":{"value":"#ffffff","animation":{"enable":false,"speed":1,"sync":true}},"life":{"count":0,"delay":{"random":{"enable":false,"minimumValue":0},"value":0,"sync":false},"duration":{"random":{"enable":false,"minimumValue":0.0001},"value":0,"sync":false}},"links":{"blink":false,"color":{"value":"#ffffff"},"consent":false,"distance":150,"enable":true,"frequency":1,"opacity":0.5,"shadow":{"blur":5,"color":{"value":"#00ff00"},"enable":false},"triangles":{"enable":false,"frequency":1},"width":1,"warp":false},"move":{"angle":{"offset":45,"value":90},"attract":{"enable":false,"rotate":{"x":3000,"y":3000}},"direction":"none","distance":0,"enable":true,"gravity":{"acceleration":9.81,"enable":false,"maxSpeed":50},"noise":{"delay":{"random":{"enable":false,"minimumValue":0},"value":0},"enable":false},"outModes":{"default":"bounce","bottom":"bounce","left":"bounce","right":"bounce","top":"bounce"},"random":false,"size":false,"speed":6,"straight":false,"trail":{"enable":false,"length":10,"fillColor":{"value":"#000000"}},"vibrate":false,"warp":false},"number":{"density":{"enable":true,"area":800,"factor":1000},"limit":0,"value":80},"opacity":{"random":{"enable":false,"minimumValue":0.1},"value":0.5,"animation":{"enable":false,"minimumValue":0,"speed":2,"sync":false}},"reduceDuplicates":false,"rotate":{"random":{"enable":false,"minimumValue":0},"value":0,"animation":{"enable":false,"speed":0,"sync":false},"direction":"clockwise","path":false},"shadow":{"blur":0,"color":{"value":"#000000"},"enable":false,"offset":{"x":0,"y":0}},"shape":{"options":{},"type":"square"},"size":{"random":{"enable":true,"minimumValue":1},"value":5,"animation":{"destroy":"none","enable":false,"minimumValue":0,"speed":5,"startValue":"max","sync":false}},"stroke":{"width":0},"twinkle":{"lines":{"enable":false,"frequency":0.05,"opacity":1},"particles":{"enable":false,"frequency":0.05,"opacity":1}}},"pauseOnBlur":true,"pauseOnOutsideViewport":false,"themes":[]},
        particleDetails: [
          {options:  {"background":{"color":{"value":"#0d47a1"},"image":""},"particles":{"number":{"value":80,"density":{"enable":false}},"size":{"value":3,"random":true,"anim":{"speed":4,"size_min":0.3}},"links":{"enable":false},"move":{"random":true,"speed":1,"direction":"top","out_mode":"out"}},"interactivity":{"events":{"onhover":{"enable":true,"mode":"bubble"},"onclick":{"enable":true,"mode":"repulse"}},"modes":{"bubble":{"distance":250,"duration":2,"size":0,"opacity":0},"repulse":{"distance":400,"duration":4}}}},
          gradient: "linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)",
          container: {}},
          {options:  {"background":{"color":{"value":"#0d47a1"},"image":""},"particles":{"number":{"value":80,"density":{"enable":false}},"size":{"value":3,"random":true,"anim":{"speed":4,"size_min":0.3}},"links":{"enable":false},"move":{"random":true,"speed":1,"direction":"top","out_mode":"out"}},"interactivity":{"events":{"onhover":{"enable":true,"mode":"bubble"},"onclick":{"enable":true,"mode":"repulse"}},"modes":{"bubble":{"distance":250,"duration":2,"size":0,"opacity":0},"repulse":{"distance":400,"duration":4}}}},
          gradient: "linear-gradient(45deg, #5757D9 0%, #21D9F7 100%)",
          container: {}},
          {options:  {"background":{"color":{"value":"#0d47a1"},"image":""},"particles":{"number":{"value":80,"density":{"enable":false}},"size":{"value":3,"random":true,"anim":{"speed":4,"size_min":0.3}},"links":{"enable":false},"move":{"random":true,"speed":1,"direction":"top","out_mode":"out"}},"interactivity":{"events":{"onhover":{"enable":true,"mode":"bubble"},"onclick":{"enable":true,"mode":"repulse"}},"modes":{"bubble":{"distance":250,"duration":2,"size":0,"opacity":0},"repulse":{"distance":400,"duration":4}}}},
        gradient: "linear-gradient(90deg, hsla(312, 66%, 76%, 1) 0%, hsla(234, 93%, 67%, 1) 100%)", 
        container: {}},
        ],
        showModal: false,
        gradient_body: {},
        gradient_elems: [],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.createGradients();

  }

  createParticleElems() {
    var particle_elems = this.state.particleDetails.map((particle, i) => {
      return (
        <article className="flex flex-col h-full" data-aos="zoom-y-out">
        <header>
          {/* <Link to="/app?designType=svgOverlay" className="block mb-6"> */}
            <figure className="relative h-0 pb-9/16 overflow-hidden translate-z-0 rounded">

              {/* <div
              className="gradient absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
              // onClick={() => this.handleClick(gradient)}
              style={{
              width: "352",
              height: "198",
              backgroundImage: `linear-gradient(${gradient.deg}deg, ${gradient.color1}, ${gradient.color2})`,
              }}
              /> */}
{/* 
            <Particles particlesRef={particle.container}
            params={particle.options} 
            style={{background: `${particle.gradient}`}}/> */}
              
            </figure>
          {/* </Link> */}
          <div className="mb-3">

          </div>
          <h3 className="text-xl font-bold leading-snug tracking-tight">
            {/* <Link to="/app?designType=svgOverlay" className="hover:underline"></Link> */}
          </h3>
        </header>

      </article>
      )
    }
  )

  return particle_elems;
  }

    getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    displayModal(gradient) {
      this.setState({showModal: true, gradient_body: gradient})
  }

  hideModal() {
    this.setState({showModal: false})
  }

  createGradients() {
    let gradients = [];
    for (var i = 0; i < 21; i++) {
      let ran_num = this.getRandomNumber(40, 300);
      let l = this.getRandomNumber(25, 75);
      let l1 = this.getRandomNumber(25, 75);

      let ran_num2 = this.getRandomNumber(20, 70);
      let color = `hsla(${ran_num}, 100%, ${ran_num2}%, 1)`;
      let color2 = `hsla(${ran_num}, 100%, ${this.getRandomNumber(ran_num2 + 30, 90)}%, 1)`;
      let color3 = `hsla(${ran_num}, 75%, ${l}%, 1)`;
      let color4 = `hsla(${ran_num + 100}, 75%, ${l}%, 1)`;
      let gradient_name = "Gradient" + i;
      let gradient_body = {color1: color3, color2: color4, name: gradient_name }
      gradients.push(gradient_body)
    }
    return gradients;
  }

  getSvgString() {
    let svg_string = `<svg viewBox="0 0 140 140" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
 <defs>
   <radialGradient id="${this.state.gradient_body.name}"
   cx="21.152%"
   cy="86.063%"
   fx="21.152%"
   fy="86.063%"
   r="79.941%">
     <stop offset="0%" stop-color="${this.state.gradient_body.color1}" />
     <stop offset="100%" stop-color="${this.state.gradient_body.color2}" />
   </radialGradient>
 </defs>

 <circle cx="5" cy="5" r="4" fill="url('#${this.state.gradient_body.name}')" />
</svg>
`;
  return svg_string;
  }


  createGradientElems() {
    let gradients;
    if (this.state.gradients.length == 0) {
      gradients = this.createGradients();
      this.setState({gradients: gradients})
    }
    else {
      gradients = this.state.gradients;
    }


    var image_elems = gradients.map((gradient, i) => {


      return (
          <article className="flex flex-col h-full cursor-pointer" data-aos="zoom-y-out" onClick={() => this.displayModal(gradient)}>
          <div>

          <svg
                viewBox="0 0 140 140"
                width="140"
                height="140"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <radialGradient
                    cx="21.152%"
                    cy="86.063%"
                    fx="21.152%"
                    fy="86.063%"
                    r="79.941%"
                    id={gradient.name}
                  >
                    <stop stopColor={gradient.color1} offset="0%" />
                    <stop stopColor={gradient.color2} offset="100%" />
                  </radialGradient>
                </defs>
                <rect
                  width="140"
                  height="140"
                  rx="70"
                  fill={"url(#" + gradient.name + ")"}
                  fillRule="nonzero"
                />
              </svg>
{/* 
              <svg
                viewBox="0 0 140 140"
                width="140"
                height="140"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <radialGradient
                    cx="21.152%"
                    cy="86.063%"
                    fx="21.152%"
                    fy="86.063%"
                    r="79.941%"
                    id={gradient.name + "1"}
                  >
                    <stop stopColor={color4} offset="0%" />
                    <stop stopColor={color3} offset="100%" />
                  </radialGradient>
                </defs>
                <rect
                  width="140"
                  height="140"
                  rx="70"
                  fill={"url(#" + gradient.name + "1" + ")"}
                  fillRule="nonzero"
                />
              </svg> */}


              {/* <figure className="relative h-0 pb-9/16 overflow-hidden translate-z-0 rounded">


                <div
                className="gradient absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
                // onClick={() => this.handleClick(gradient)}
                style={{
                width: "352",
                height: "198",
                backgroundImage: `linear-gradient(${gradient.deg}deg, ${color3}, ${color4})`,
                }}
                /> 

                
              </figure> */}

            <div className="mb-3">

            </div>
            <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
              {/* <Link to="/app?designType=svgOverlay" className="hover:underline"></Link> */}
            </h3>
          </div>

        </article>

      );
    });
    return image_elems;
  }

  createImageElems() {
    var image_elems = this.state.image_links.map((image_link, i) => {
      return (
          <article className="flex flex-col h-full" data-aos="zoom-y-out">
          <header>
            {/* <Link to="/app?designType=svgOverlay" className="block mb-6"> */}
              <figure className="relative h-0 pb-9/16 overflow-hidden translate-z-0 rounded">

                {/* <div
                className="gradient absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
                // onClick={() => this.handleClick(gradient)}
                style={{
                width: "352",
                height: "198",
                backgroundImage: `linear-gradient(${gradient.deg}deg, ${gradient.color1}, ${gradient.color2})`,
                }}
                />  */}

                <img className="absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
                      src={require(`../../static/img/${image_link}.jpg`)} width="352" height="198" alt="An example of a background" />
                    
              
              </figure>
            {/* </Link> */}
            <div className="mb-3">

            </div>
            <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
              {/* <Link to="/app?designType=svgOverlay" className="hover:underline"></Link> */}
            </h3>
          </header>

        </article>

      );
    });
    return image_elems;
  }

  updateGradients() {
    let gradients = this.createGradients();
    this.setState({gradients: gradients});
    window.scrollTo(0, 0);

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.gradient_elems != this.props.gradient_elems) {

    }
}

  render() {


    let gradient_elems = this.createGradientElems();

    // let particle_elems = this.createParticleElems();

    // let image_elems = this.createImageElems();

    return (
        <div className="flex flex-col min-h-screen overflow-hidden bg-grey-200">                  

        {/*  Page content */}
        <main className="flex-grow">
  
          {/*  Page sections */}
          <section>
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
              <div className="pt-8 pb-2 md:pt-14 md:pb-6">

                {/* Section header */}
                <div className="max-w-6xl mx-auto text-center pb-6 md:pb-12">
                  <h1 className="h1 mb-8 text-5xl font-extrabold leading-tight tracking-tighter bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400" data-aos="zoom-y-out">Gradient Generator</h1>
                  <p className="text-xl text-gray-600" data-aos="zoom-y-out" data-aos-delay="150">
                    Generate gradients instantly with this tool, click on a gradient to export its CSS/SVG!
                    {/* Click on a background to preview it; it will represent the exported background. */}
                  </p>
                </div>
            <div className="grid gap-4 md:gap-12 grid-cols-2 md:grid-cols-3 md:col-gap-6 md:row-gap-8 items-end ml-10">

              {/* 1st gradient */}
            {gradient_elems}
            {/* {image_elems}
            {particle_elems} */}
            </div>

              </div>
            </div>

            
      <div className="max-w-6xl mx-auto px-4 sm:px-6 bg-grey-600">
        <div className="pb-2 md:pb-4">

          {/* Gradients list */}
          <div className="max-w-sm mx-auto md:max-w-none">

            {/* Gradients container */}


          </div>

          <p className="text-xl text-gray-600 text-center" data-aos="zoom-y-out" data-aos-delay="150">
                    ... want more tools like this? <Link to="/join-waitlist">Join the waitlist</Link> to be notified of when we launch more tools.
          </p>
          <button onClick={() => this.updateGradients()} type="button" class="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                    More Gradients!
          </button>
        </div>
      </div>
          </section>
  
        </main>

        <div className={this.state.showModal ? "" : "hidden"}>

          <div class="fixed z-999999999 inset-0 overflow-y-auto pt-20">
            <div class="flex items-end justify-center min-h-screen pt-30 px-4 pb-20 text-center sm:block sm:p-0">

              <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
              </div>

              <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

              <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div class="sm:flex sm:items-start">

                    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <svg
                      viewBox="0 0 140 140"
                      width="80"
                      height="80"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <radialGradient
                          cx="21.152%"
                          cy="86.063%"
                          fx="21.152%"
                          fy="86.063%"
                          r="79.941%"
                          id={this.state.gradient_body.name}
                        >
                          <stop stopColor={this.state.gradient_body.color1} offset="0%" />
                          <stop stopColor={this.state.gradient_body.color2} offset="100%" />
                        </radialGradient>
                      </defs>
                      <rect
                        width="80"
                        height="80"
                        rx="40"
                        fill={"url(#" + this.state.gradient_body.name + ")"}
                        fillRule="nonzero"
                      />
                    </svg>
                      <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                        Copy gradient
                      </h3>
                      <div class="mt-2">
                        <p class="text-sm text-gray-500">
                          Copy the CSS below or the SVG underneath for a circle gradient.
                        </p>
                      </div>
                      <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                        CSS
                      </h3>
                      <textarea class="resize border rounded-md text-sm w-full" value={`background: linear-gradient(90deg, ${this.state.gradient_body.color1} 0%, ${this.state.gradient_body.color2} 100%);`}></textarea>
                    <p className="mt-2">or</p>
                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                        SVG
                    </h3>
                    <textarea class="resize border rounded-md text-sm w-full" value={this.getSvgString()}></textarea>
                    </div>

                  </div>
                </div>
                <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <button onClick={() => this.hideModal()} type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                    Done
                  </button>
                  <button onClick={() => this.hideModal()} type="button" class="mt-3 align-center content-center inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default FrontendResources;